import debounce from 'lodash/debounce';
import delay from 'lodash/delay';
import sample from 'lodash/sample';
import forEach from 'lodash/forEach';
//import $ from 'jquery';
import aos from 'aos';

//services
import crossfadeSlideShow from './service/cross-fade-slideshow';
//import newsGallery from './service/news-gallery';
//import updateBodyClass from './service/update-body-class';
import showMobileMenu from './service/show-mobile-menu';
import hideMobileMenu from './service/hide-mobile-menu';
import animateClientCarousel from './service/animate-client-carousel';
import scrollAction from './service/scroll-action';
import videoPlayer from './service/video-player';
//import accordion from './service/accordion';
//import blockquoteCarousel from './service/blockquote-carousel';
import pagination from './service/pagination';
import general from './service/general';
import cookieNotice from './service/cookie-notice';
import trackExternalClicks from './service/track-external-clicks';
//import featureSlideShow from './service/feature-fade-slideshow';
//import shuffleClientGrid from './service/shuffle-client-grid';
import workAnimateImg from './service/work-animate-img';
import tourCarousel from './service/tour-carousel';



const
    //docBody = $(document.body),
    //win = $(window),
    mobileNav = document.querySelector('.nav.menu'),
    overlay = document.querySelector('.overlay'),
    hamburger = document.querySelector('.hamburger'),
    activeClassNames = ['active', ['active', 'alt']],
    currentBraceCollection = document.querySelectorAll('.brace, .footer');


/**
 * @brief [brief description]
 * @details [long description]
 * 
 * @param t [description]
 * @param s [description]
 * 
 * @return [description]
 */
const makeBodyActive = () => {
    general.addClass(document.body, sample(activeClassNames));
}

/**
 * @brief [brief description]
 * @details [long description]
 * @return [description]
 */
const mobileMenuEvent = () => {
    hamburger.addEventListener('click', (e) => {
        if (!mobileNav.classList.contains('active')) {
            showMobileMenu();
        } else {
            hideMobileMenu();
        }
    }, false);
}


const hideFlashMessage = () => {

    const elementCollection = document.querySelectorAll('.popup.flash');
    forEach(elementCollection, (el, i) => {

        el.addEventListener('click', (e) => {
            e.preventDefault();
            el.parentNode.removeChild(el);
        })

    })


}

delay(makeBodyActive, 100);

//document.body.classList.add(sample(activeClassNames));

if (overlay) {

    //when the maincontainer has finished transitioning then implment the rest of the js events
    overlay.addEventListener('transitionend', (e) => {

        if (e.propertyName === 'opacity') {

            //scroll animation
            aos.init({
                disable: 'phone',
                easing: 'ease-in-sine',
                delay: 500,
            });

            //homepage slideshow
            /*if (slideShowElement) {
                setInterval(crossfadeSlideShow, 7000);
            }*/

            //show the mobile menu when hamburger is clicked
            mobileMenuEvent();

            //shuffleClientGrid();
            animateClientCarousel();
            //newsGallery();

            //pagination.init();
            //general.init();
            videoPlayer.init();
            //accordion.init();
            //blockquoteCarousel.init();
            scrollAction.init(currentBraceCollection);
            cookieNotice.init();
            trackExternalClicks.init();
            //featureSlideShow.init();
            crossfadeSlideShow.init();
            workAnimateImg.init();
            tourCarousel.init();

            hideFlashMessage();



        }
    });

};



// WEBPACK FOOTER //
// ./js/index.js